// extracted by css-extract-rspack-plugin
export default {"locale_switchers":"AONqH","localeSwitchers":"AONqH"};